"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _awilix = require("awilix");

var _service = _interopRequireDefault(require("./service"));

var _lifecycle = _interopRequireDefault(require("./lifecycle"));

var _frame = _interopRequireDefault(require("./frame"));

var container = (0, _awilix.createContainer)({
  injectionMode: _awilix.InjectionMode.PROXY
});

var _default = function _default(adapter, options) {
  var sensors = (0, _frame.default)(adapter, options);
  (0, _service.default)(container).initialize(sensors);
  return {
    run: function run() {
      (0, _lifecycle.default)(container.cradle).run();
    }
  };
};

exports.default = _default;